import { z } from 'zod';
import { IsoDateSchema } from './common.js';
import { ConfidenceSchema } from './events.js';
export const EVENT_TYPES = [
    'campaign',
    'revival',
    'sync',
    'playlist',
    'social',
    'release',
    'live',
    'award',
    'other',
];
export const EventTypeSchema = z.enum(EVENT_TYPES);
export const AttributionInputSchema = z.object({
    cause: z.string().min(3).max(1000),
    sourceUrl: z.url().max(2000).optional(),
    confidence: ConfidenceSchema,
    /** Defaults to the first day of the event month. */
    eventDate: IsoDateSchema.optional(),
    eventType: EventTypeSchema,
    /** Link an existing ghost known_event instead of creating one. */
    knownEventId: z.number().int().optional(),
});
export const KnownEventSchema = z.object({
    id: z.number().int(),
    artistId: z.string(),
    eventDate: IsoDateSchema,
    title: z.string(),
    eventType: z.string(),
    impact: z.string().nullable(),
    sources: z.array(z.string()),
    confidence: z.string().nullable(),
    addedBy: z.string().nullable(),
});
//# sourceMappingURL=attributions.js.map